export default "__VITE_PUBLIC_ASSET__b633f80f__"